import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-terms-conditions-page',
  templateUrl: './terms-conditions-page.component.html',
  styleUrls: ['./terms-conditions-page.component.css']
})
export class TermsConditionsPageComponent implements OnInit {

  pageName = "Privacy Policy"
  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
